import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckoutFormNew from "./StripeCheckoutForm_New";
import config from "../../../../utils/config/config";

const StripePaymentsNew = (props) => {
	const stripePromise = loadStripe(config.paymentGatewayKey);

	return (
		<div>
			<Elements stripe={stripePromise}>
				<StripeCheckoutFormNew {...props} />
			</Elements>
		</div>
	);
};
export default StripePaymentsNew;
